
export function processContactData( communityData, salesCounselorData ) {
  if ( !communityData && !salesCounselorData ) {
    return;
  }

  // PIB API uses email/phone/firstName/lastName/name; JSON:API uses mail/fieldPhone/fieldFirstName/fieldLastName.
  const email = salesCounselorData?.mail
    || salesCounselorData?.email
    || communityData?.email;
  const phone = salesCounselorData?.fieldPhone
    || salesCounselorData?.phone
    || communityData?.phone;
  const first = salesCounselorData?.fieldFirstName || salesCounselorData?.firstName;
  const last = salesCounselorData?.fieldLastName || salesCounselorData?.lastName;
  const name = salesCounselorData?.name
    || ( first && last ? `${first} ${last}`.trim() : first || last || 'us' );

  return {
    email,
    phone,
    name,
  }
}